import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { DAYS } from "@/lib/clientAdmin";

// §79 Client-side weekly digest preference (day of week, on/off). 8am in the user's timezone.
export const DigestSettings = ({ readOnly }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/client/digest").then((r) => setD(r.data)).catch(() => setD({ missing: true })); }, []);
  const save = async (patch) => {
    const next = { ...d, ...patch }; setD(next);
    try { await api.put("/client/digest", { enabled: next.enabled, day: next.day, hour: 8, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }); toast.success(next.enabled ? `Weekly digest: ${DAYS.find(([k]) => k === next.day)?.[1]}s at 8am` : "Weekly digest turned off"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!d || d.missing) return null;
  return (
    <Popover>
      <PopoverTrigger asChild><button title="Weekly digest" className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[#27272A] bg-[#0f0f12] text-zinc-400 transition-colors hover:border-[#D4AF37]/50 hover:text-[#F3C649]" data-testid="client-digest"><Mail className="h-4 w-4" /><span className="sr-only">Weekly digest</span></button></PopoverTrigger>
      <PopoverContent align="end" className="w-72 space-y-3 border-[#27272A] bg-[#0f0f12] p-4" data-testid="client-digest-panel">
        <label className="flex items-center justify-between text-sm text-zinc-200">Email me a weekly summary<Switch checked={!!d.enabled} disabled={readOnly} onCheckedChange={(v) => save({ enabled: v })} data-testid="client-digest-toggle" /></label>
        <select value={d.day || "mon"} disabled={!d.enabled || readOnly} onChange={(e) => save({ day: e.target.value })} className="h-9 w-full rounded-md border border-[#27272A] bg-[#18181B] px-2 text-sm text-zinc-200 disabled:opacity-50" data-testid="client-digest-day">{DAYS.map(([k, l]) => <option key={k} value={k}>{l}s at 8am</option>)}</select>
        <p className="text-[11px] text-zinc-500">New hot companies and decision makers from your workflows. If nothing new turns up, you'll get a short quiet-week note.</p>
      </PopoverContent>
    </Popover>
  );
};
